<template>
  <button @click="clickEvent" :class="disabled ? 'inline-block is-disabled' : 'inline-block'">
    <template v-if="isText">
      <div :class="getTextStyle" :style="'color:'+color" v-if="text && isText">
        <slot>{{ text }}</slot>
      </div>
    </template>
    <template v-else>
      <div v-if="mod == 1" class="mod1">
        <div :class="disabled ? 'custom-button disabled' : 'custom-button'" :style="'border-color:'+borderColor+';color:'+color">
          <slot>{{ text }}</slot>
        </div>
      </div>
      <div v-else-if="mod == 2" class="mod2">
        <div :class="getButtonStyle"
             :style="primary ? '' : `background: ${color};border-color: ${color};`">
          <slot>{{ text }}</slot>
        </div>
      </div>
    </template>

  </button>
</template>

<script>
export default {
  name: "clickButton",
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    color: {
      type: String,
      default: '#595959'
    },
    mod: {
      type: String | Number,
      default: 1
    },
  },
  data() {
    return {
      bgColor: null,
      borderColor: null,
    }
  },
  watch: {
    color: {
      handler() {
        this.setColor()
      },
      immediate: true
    }
  },
  created() {

  },
  computed: {
    getTextStyle(){
      let style = "custom-text"
      if(this.primary){
        style += " primary-text"
      }
      if(this.disabled){
        style += " disabled-text"
      }
      return style
    },
    getButtonStyle(){
      let style = "custom-button"
      if(this.primary){
        style += " primary"
      }
      if(this.disabled){
        style += " disabled"
      }
      return style
    }
  },
  methods: {
    setColor() {
      if (this.color) {
        let rgb = this.$tool.hex2rgb(this.color)
        this.bgColor = "rgba(" + rgb + ", 0.1)"
        if(this.color === '#595959'){
          this.borderColor = "#DCDFE6"
        }else {
          this.borderColor = "rgba(" + rgb + ", 0.6)"
        }
      }
    },
    clickEvent() {
      if(this.disabled) return
      if(this.$listeners["click"]){
        this.$emit("click")
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "/src/style/variables";

.disabled{
  background: rgba(0, 0, 0, .04) !important;
  border: 1px solid rgba(0, 0, 0,.15) !important;
  color: #C0C4CC !important;
  cursor: not-allowed !important;
}

.disabled-text{
  color: #C0C4CC !important;
  cursor: not-allowed !important;
}


.mod1 {
  .custom-button {
    height: 30px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #00ACD4;
    background-color: white;

    padding: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
  }
}

.mod2 {
  .custom-button {
    height: 30px;
    border-radius: 4px;
    box-sizing: border-box;

    padding: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;

  }

  .primary {
    background: @--default-bg-color;
    border: 1px solid @--color-primary;
  }
}

.custom-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
}

.primary-text {
  color: @--color-primary !important;
}

.inline-block{
  border: none;
  background: unset;
}
</style>